import { useQuery } from '@tanstack/react-query';
import { recipeService } from '@/services/recipe';
import { RECIPES } from '@/constants/queryKeys';
import { useUser } from '@/contexts/UserContext';

export const useRecipes = () => {
  const { user } = useUser();
  
  return useQuery({
    queryKey: [RECIPES],
    queryFn: recipeService.getRecipes,
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};